import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface IicProgram {
  title: string;
  description: string;
  icon: string;
}

interface IicMember {
  sno: number;
  memberName: string;
  designation: string;
  role: string;
}

@Component({
  selector: 'app-edit-address-page',
  templateUrl: './edit-address-page.component.html',
  styleUrls: ['./edit-address-page.component.scss']
})
export class EditAddressPageComponent implements OnInit {
  isToggled = false;

  programs: IicProgram[] = [
    {
      title: 'Innovation Ambassador Program',
      description:
        'Building in-house human resource capacity to engage, manage, and generate innovation and entrepreneurship through training and mentoring support for students and faculty.',
      icon: 'bx bx-shape-triangle'
    },
    {
      title: 'Impact Lecture Session',
      description:
        'Funding support for HEIs located away from established innovation ecosystems to organize impact lectures and strengthen institutional innovation performance.',
      icon: 'bx bx-font-family'
    },
    {
      title: 'Innovation Contest',
      description:
        'A 360-degree experiential learning opportunity designed for potential student innovators and young entrepreneurs.',
      icon: 'bx bxs-drink'
    },
    {
      title: 'Mentor-Mentee Program',
      description:
        'Peer-group mentoring with institutional support to improve innovation culture and enable inter-institutional collaboration.',
      icon: 'bx bx-first-aid'
    }
  ];

  committeeMembers: IicMember[] = [
    {
      sno: 1,
      memberName: 'Dr. P. Nelson Raja',
      designation: 'Principal',
      role: 'President'
    },
    {
      sno: 2,
      memberName: 'Dr. R. Natarajan',
      designation: 'HoD / EEE',
      role: 'Vice-President / NIRF / IQAC Coordinator / Member'
    },
    {
      sno: 3,
      memberName: 'Dr. G. Dhinesh',
      designation: 'Director / M.B.A',
      role: 'Start up Activity / EDC Coordinator / Member'
    },
    {
      sno: 4,
      memberName: 'Dr. K. R. Ramela',
      designation: 'Professor / EEE',
      role: 'RD Cell Coordinator'
    },
    {
      sno: 5,
      memberName: 'Dr. P. Ravikumaran',
      designation: 'HoD / CSE',
      role: 'IPR Activity Coordinator / Member'
    },
    {
      sno: 6,
      memberName: 'Mr. M. Siva Ganesh',
      designation: 'Associate Professor-HoD / CS',
      role: 'Convener'
    },
    {
      sno: 7,
      memberName: 'Mr. M. Mohamed Ajmal Khan',
      designation: 'Associate Professor / EEE',
      role: 'Innovation Activity / Member'
    },
    {
      sno: 8,
      memberName: 'Mr. G. Balakrishnan',
      designation: 'Associate Professor / CSE',
      role: 'Social Media / Member'
    },
    {
      sno: 9,
      memberName: 'Mrs. S. Vinothini',
      designation: 'Assistant Professor / CSE',
      role: 'Internship Activity Coordinator / Member'
    },
    {
      sno: 10,
      memberName: 'Dr. S. Muthupoongodi',
      designation: 'Assistant Professor / Chemistry',
      role: 'Member'
    },
    {
      sno: 11,
      memberName: 'Mr. M. Prabakaran',
      designation: 'Associate Professor-HoD / MECH',
      role: 'Member'
    },
    {
      sno: 12,
      memberName: 'Mr. J. Thavaseelan',
      designation: 'Associate Professor-HoD / Civil',
      role: 'Member'
    },
    {
      sno: 13,
      memberName: 'Ms. R. Nagadeepa',
      designation: 'Assistant Professor / ECE',
      role: 'Member'
    },
    {
      sno: 14,
      memberName: 'Mr. H. Ganesh',
      designation: 'Assistant Professor / MECH',
      role: 'Member'
    },
    {
      sno: 15,
      memberName: 'Ms. P. Geetha',
      designation: 'Assistant Professor / MBA',
      role: 'Member'
    },
    {
      sno: 16,
      memberName: 'Mr. S. Karthikeyan',
      designation: 'Assistant Professor / CIVIL',
      role: 'Member'
    },
    {
      sno: 17,
      memberName: 'Mrs. G. Hemavathi',
      designation: 'Assistant Professor / CS',
      role: 'Member'
    },
    {
      sno: 18,
      memberName: 'Ms. K. Maheswari',
      designation: 'Assistant Professor / AIML',
      role: 'Member'
    }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });
  }

  ngOnInit(): void {}

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  trackBySno(index: number, item: IicMember): number {
    return item.sno;
  }

  trackByTitle(index: number, item: IicProgram): string {
    return item.title;
  }
}